<div class="mz-truncate" [mazarsTooltip]="tooltipText" [escape]="false" [attr.data-testid]="uid">
    <span *ngFor="let owner of propertyOwners" class="label label-inline m-1" [ngClass]="{ 'mz-red': owner.name === null }">
        {{ owner.name ? owner.name : l('Entry_Got_Deleted') }}
    </span>
</div>
